import { ILocalizationProvider } from "@edaz/services/baseLocalizationService";
import { LocalizationContainer } from "services/localizationService";

import cs from "../localization/cs.json";
import en from "../localization/en.json";
import de from "../localization/de.json";
import pl from "../localization/pl.json";
import ru from "../localization/ru.json";
import hu from "../localization/hu.json";

export default class LocalizationRepository implements ILocalizationProvider {
  async get(language: string): Promise<LocalizationContainer> {
    switch (language) {
      case "en":
      case "en-GB":
        return en as LocalizationContainer;
      case "de":
        return de as LocalizationContainer;
      case "pl":
        return pl as LocalizationContainer;
      case "ru":
        return ru as LocalizationContainer;
      case "hu":
        return hu as LocalizationContainer;
      case "cs":
      default:
        return cs as LocalizationContainer;
    }
  }
}
